export default __webpack_public_path__ + "static/media/gweistation.df6bafe4.png";